import { useUserStore } from '@/config/store/userStore'

export const canUserAccessModule = (user = useUserStore().user) => {
  return user.profile.isSubAdminProfile
}

const getGlobalSettingsAccess = (key: string) => {
  const userStore = useUserStore()
  const user = userStore.user

  if (!canUserAccessModule(user)) {
    return { name: 'Home' }
  }

  const globalSettings = user.profile?.modules?.globalSettings || {}
  const scopedAccess = globalSettings[key]

  return !!scopedAccess
}

export const guardUsers = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return canUserAccessModule(user) ? user.profile.modules.globalSettings.userAccess : { name: 'Home' }
}

export const guardClientAdmin = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return canUserAccessModule(user) ? user.role === 'client_admin' : { name: 'Home' }
}

export const guardPersonalisation = () => getGlobalSettingsAccess('personalisationAccess')

export const guardConsumption = () => getGlobalSettingsAccess('consumptionAccess')

export const guardProfiles = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return canUserAccessModule(user) ? user.profile.modules.globalSettings.userAccess && user.profile.modules.globalSettings.profileAccess : { name: 'Home' }
}

export const guardSessions = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return canUserAccessModule(user) ? user.profile.modules.globalSettings.sessionAccess : { name: 'Home' }
}

export const guardOpenReplay = () => getGlobalSettingsAccess('openReplayAccess')

export const guardApiUsers = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.role === 'client_admin' ? true : { name: 'Home' }
}

export const guardIntegrations = () => getGlobalSettingsAccess('integrationAccess')

export const guardDataJobs = () => getGlobalSettingsAccess('dataJobAccess')

export const guardDataClients = () => getGlobalSettingsAccess('dataClientAccess')

export const guardDataDegrees = () => getGlobalSettingsAccess('dataDegreeAccess')

export const guardDataSkills = () => getGlobalSettingsAccess('dataSkillAccess')

export const guardDataOffices = () => getGlobalSettingsAccess('dataOfficeAccess')

export const guardDataRooms = () => getGlobalSettingsAccess('dataRoomAccess')

export const guardDataResources = () => getGlobalSettingsAccess('dataResourceAccess')

export const guardDataInvoicingInformations = () => getGlobalSettingsAccess('dataInvoicingInformationAccess')

export const guardDataTeams = () => getGlobalSettingsAccess('dataTeamAccess')

export const guardDataUserGroups = () => getGlobalSettingsAccess('dataUserGroupAccess')
